<!-- Form -->
<h1> Questionnaire d'impôt des particuliers </h1>
<p>Votre cabinet comptable vous a envoyé ce questionnaire à remplir afin de faciliter la collecte de vos
informations.</p>

<div class="row">
  <div class="col-12">
    <h2>Informations personnelles</h2>

    <div class="row">
      <div class="col-12 col-lg-3">
        <magieno-input-text-field
                [advancedFormControl]="this.baseSpouseForm.formElements.firstname | asAdvancedFormControl"
          type="string"
        ></magieno-input-text-field>
      </div>
      <div class="col-12 col-lg-3">
        <magieno-input-text-field
                [advancedFormControl]="this.baseSpouseForm.formElements.lastname | asAdvancedFormControl"
                type="string"></magieno-input-text-field>
      </div>
    </div>

    <magieno-boolean-select
            [advancedFormControl]="this.baseSpouseForm.formElements.doYouAcceptToReceiveYourNoticeOfAssessmentByEmail | asAdvancedFormControl"></magieno-boolean-select>

    <magieno-datepicker
      [advancedFormControl]="this.baseSpouseForm.formElements.dateOfBirth | asAdvancedFormControl"
      [maxDate]="birthdayMaxDate"
      [minDate]="birthdayMinDate"
    >
      <i class="fas fa-calendar" calendarIcon></i>
    </magieno-datepicker>

    <magieno-input-text-field [advancedFormControl]="this.baseSpouseForm.formElements.address | asAdvancedFormControl"
      [width]="'XL'"
                              type="string"></magieno-input-text-field>

    <magieno-input-text-field
      [advancedFormControl]="this.baseSpouseForm.formElements.socialInsuranceNumber | asAdvancedFormControl"
      [width]="'SM'"
      type="string"></magieno-input-text-field>


    <magieno-input-text-field
      [advancedFormControl]="this.baseSpouseForm.formElements.homePhoneNumber | asAdvancedFormControl"
      [width]="'SM'"
      type="string"></magieno-input-text-field>


    <magieno-input-text-field
      [advancedFormControl]="this.baseSpouseForm.formElements.cellPhoneNumber | asAdvancedFormControl"
      [width]="'SM'"
      type="string"></magieno-input-text-field>

    @if (this.isMainSpouse) {
      <magieno-select
              [advancedFormControl]="this.advancedForm.formElements.civilStatus | asAdvancedFormControl"></magieno-select>
    }

    <h3 class="mt-5">Changement d'état durant l'année</h3>

    <magieno-boolean-select
            [advancedFormControl]="this.baseSpouseForm.formElements.hasCivilStatusChangedDuringThisFiscalYear | asAdvancedFormControl"></magieno-boolean-select>

    @if (this.baseSpouseForm.value.hasCivilStatusChangedDuringThisFiscalYear) {
      <div
        class="card">
        <div class="card-body">
          <magieno-datepicker
                  [advancedFormControl]="this.baseSpouseForm.formElements.civilStatusChangeDate | asAdvancedFormControl">
            <i class="fas fa-calendar" calendarIcon></i>
          </magieno-datepicker>
        </div>
      </div>
    }

    <h3 class="mt-5">Information en lien avec votre déclaration d'impôts</h3>

    @if (this.isMainSpouse && this.advancedForm.value.civilStatus === civilStatusEnum.Married || this.advancedForm.value.civilStatus === civilStatusEnum.LivingCommonLaw) {
      <magieno-boolean-select
              [advancedFormControl]="this.advancedForm.formElements.isSpouseTaxPrepared | asAdvancedFormControl"></magieno-boolean-select>
    }
    @if (this.isMainSpouse && this.advancedForm.value.isSpouseTaxPrepared === false) {
      <div
        class="card">
        <div class="card-body">
          <magieno-input-money-field
            [advancedFormControl]="this.advancedForm.formElements.spouseFederalNetIncome | asAdvancedFormControl"
            [currency]="this.currency"
            [locale]="this.locale"></magieno-input-money-field>
          <magieno-input-money-field
            [advancedFormControl]="this.advancedForm.formElements.spouseQuebecNetIncome | asAdvancedFormControl"
            [currency]="this.currency"
            [locale]="this.locale"></magieno-input-money-field>
        </div>
      </div>
    }

    @if (this.isMainSpouse && this.advancedForm.value.isSpouseTaxPrepared === true) {
      <div class="alert alert-light"
        role="alert">
        <i class="fas fa-exclamation-triangle"></i> Veuillez remplir l'onglet conjoint.
      </div>
    }

    <magieno-boolean-select
            [advancedFormControl]="this.baseSpouseForm.formElements.areYouACanadianCitizen | asAdvancedFormControl"></magieno-boolean-select>

    <magieno-select
            [advancedFormControl]="this.baseSpouseForm.formElements.province | asAdvancedFormControl"></magieno-select>

    <magieno-boolean-select
            [advancedFormControl]="this.baseSpouseForm.formElements.isAloneAllYear | asAdvancedFormControl"></magieno-boolean-select>

    <magieno-boolean-select
            [advancedFormControl]="this.baseSpouseForm.formElements.haveYouSayedOutsideCanadaMoreThan183Days | asAdvancedFormControl"></magieno-boolean-select>

    <magieno-boolean-select
            [advancedFormControl]="this.baseSpouseForm.formElements.haveYouStayedInTheUSMoreThan120Days | asAdvancedFormControl"></magieno-boolean-select>

    <magieno-boolean-select
            [advancedFormControl]="this.baseSpouseForm.formElements.areYouDeceased | asAdvancedFormControl"></magieno-boolean-select>

    @if (this.baseSpouseForm.value.areYouDeceased) {
      <div
        class="card">
        <div class="card-body">
          <magieno-datepicker
                  [advancedFormControl]="this.baseSpouseForm.formElements.dateOfDeath | asAdvancedFormControl">
            <i class="fas fa-calendar" calendarIcon></i>
          </magieno-datepicker>
          <magieno-input-text-field
            [advancedFormControl]="this.baseSpouseForm.formElements.testamentaryLiquidatorName | asAdvancedFormControl"
            type="string"></magieno-input-text-field>
        </div>
      </div>
    }

    <magieno-boolean-select
            [advancedFormControl]="this.baseSpouseForm.formElements.doYouHavePropertyAbroad | asAdvancedFormControl"></magieno-boolean-select>

    @if (this.baseSpouseForm.value.doYouHavePropertyAbroad) {
      <div
        class="card">
        <div class="card-body">
          <magieno-input-text-field
            [advancedFormControl]="this.baseSpouseForm.formElements.propertyAbroadType | asAdvancedFormControl"
            type="string"></magieno-input-text-field>
          <magieno-input-text-field
            [advancedFormControl]="this.baseSpouseForm.formElements.propertyAbroadCountry | asAdvancedFormControl"
            type="string"></magieno-input-text-field>
        </div>
      </div>
    }

    <magieno-boolean-select
            [advancedFormControl]="this.baseSpouseForm.formElements.haveYouMadeAdvancedPayments | asAdvancedFormControl"></magieno-boolean-select>

    <br>

    <magieno-boolean-select
            [advancedFormControl]="this.baseSpouseForm.formElements.areYouRegisteredForDirectDeposit | asAdvancedFormControl"></magieno-boolean-select>

    </div>
  </div>

  <hr class="mt-5 mb-3">

  <div class="row">
    <div class="col-12">
      <h2>Travailleur</h2>
      <p>Cette section concerne les travailleurs qui sont employés et les travaulleurs autonomes.</p>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouReceivedAStatementOfRemunerationPaid | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.haveYouReceivedAStatementOfRemunerationPaid) {
        <div
          class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-lg-5">
                <magieno-boolean-select
                        [advancedFormControl]="this.baseSpouseForm.formElements.doYouHaveForeignEmploymentIncome | asAdvancedFormControl"></magieno-boolean-select>
              </div>
            </div>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.doYouHaveAT2200 | asAdvancedFormControl"></magieno-boolean-select>
            @if (this.baseSpouseForm.value.doYouHaveAT2200) {
              <div
                class="card">
                <div class="card-body">
                  <magieno-boolean-select
                          [advancedFormControl]="this.baseSpouseForm.formElements.doYouWantToFillAGST370Application | asAdvancedFormControl"></magieno-boolean-select>
                </div>
              </div>
            }
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouExercisedStockOptionsFromYourEmployer | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidProfessionalMembershipDues | asAdvancedFormControl"></magieno-boolean-select>
            @if (this.baseSpouseForm.value.haveYouPaidProfessionalMembershipDues) {
              <div
                class="card">
                <div class="card-body">
                  <magieno-boolean-select
                          [advancedFormControl]="this.baseSpouseForm.formElements.areTheProfessionalMembershipDuesPaidByYourEmployer | asAdvancedFormControl"></magieno-boolean-select>
                </div>
              </div>
            }
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPurchasedTools | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.areYouANewlyGraduateWorkingInARemoteArea | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPurchasedSchoolSupplies | asAdvancedFormControl"></magieno-boolean-select>
          </div>
        </div>
      }

      <div class="row">
        <div class="col-12 col-lg-6">
          <magieno-boolean-select
                  [advancedFormControl]="this.baseSpouseForm.formElements.haveYouReceivedAT5007 | asAdvancedFormControl"></magieno-boolean-select>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-6">
          <magieno-boolean-select
                  [advancedFormControl]="this.baseSpouseForm.formElements.haveYouReceivedAT4E | asAdvancedFormControl"></magieno-boolean-select>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-4">
          <magieno-boolean-select
                  [advancedFormControl]="this.baseSpouseForm.formElements.areYouSelfEmployed | asAdvancedFormControl"></magieno-boolean-select>
        </div>
      </div>
      @if (this.baseSpouseForm.value.areYouSelfEmployed) {
        <div
          class="card">
          <div class="card-body">
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.areYouRegisteredForTaxPerception | asAdvancedFormControl"></magieno-boolean-select>
            @if (this.baseSpouseForm.value.areYouRegisteredForTaxPerception) {
              <div
                class="card">
                <div class="card-body">
                  <magieno-boolean-select
                          [advancedFormControl]="this.baseSpouseForm.formElements.haveYouChosenTheQuickMethodOfAccountingForTaxes | asAdvancedFormControl"></magieno-boolean-select>
                </div>
              </div>
            }
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.areYouRegisteredForTheREQ | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-input-text-field
                    [advancedFormControl]="this.baseSpouseForm.formElements.legalName | asAdvancedFormControl"
                    type="string"></magieno-input-text-field>
          </div>
        </div>
      }

    </div>
  </div>


  <hr class="mt-5 mb-3">

  <div class="row">
    <div class="col-12">
      <h2>Personne âgée</h2>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.doYouHavePensionIncome | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.doYouHavePensionIncome) {

        <div
                class="card">
          <div class="card-body">
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouReceivedOldAgeSecurityPensionIncome | asAdvancedFormControl"></magieno-boolean-select>

            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouReceivedRRQPensionIncome | asAdvancedFormControl"></magieno-boolean-select>

            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouReceivedCPPRetirementPensionIncome | asAdvancedFormControl"></magieno-boolean-select>

            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouReceivedIncomeFromARRIF | asAdvancedFormControl"></magieno-boolean-select>

            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouReceivedIncomeFromARPP | asAdvancedFormControl"></magieno-boolean-select>

            @if (this.advancedForm.value.civilStatus === civilStatusEnum.LivingCommonLaw || this.advancedForm.value.civilStatus === civilStatusEnum.Married) {
              <magieno-boolean-select
                      [advancedFormControl]="this.baseSpouseForm.formElements.doYouAgreeToSplitYourPensionIncomeWithSpouse | asAdvancedFormControl"></magieno-boolean-select>
            }
          </div>
        </div>
      }

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidForHomeSupport | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidForHomeSupportEquipment | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouDoneHomeAccessibilityImprovements | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidForSeniorActivities | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidTransitUnitStayFees | asAdvancedFormControl"></magieno-boolean-select>

    </div>
  </div>

  <hr class="mt-5 mb-3">

  <div class="row">
    <div class="col-12">
      <h2>Étudiant</h2>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.areYouStudying | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.areYouStudying) {
        <div
          class="card">
          <div class="card-body">
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouWithdrawFromARESPOrHaveYouReceivedAScholarship | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidTuitionFees | asAdvancedFormControl"></magieno-boolean-select>
            @if (this.baseSpouseForm.value.haveYouPaidTuitionFees) {
              <div
                class="card">
                <div class="card-body">
                  <magieno-boolean-select
                          [advancedFormControl]="this.baseSpouseForm.formElements.areYouTuitionFeesReimbursedByYourEmployer | asAdvancedFormControl"></magieno-boolean-select>
                </div>
              </div>
            }
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.doYouHaveProfessionalExaminationFees | asAdvancedFormControl"></magieno-boolean-select>
            @if (this.baseSpouseForm.value.doYouHaveProfessionalExaminationFees) {
              <div
                class="card">
                <div class="card-body">
                  <magieno-boolean-select
                          [advancedFormControl]="this.baseSpouseForm.formElements.areYourProfessionalExaminationFeesReimbursedByYourEmployer | asAdvancedFormControl"></magieno-boolean-select>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <hr class="mt-5 mb-3">

  <div class="row">
    <div class="col-12">
      <h2> Personne handicapée </h2>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.areYouDisabled | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.areYouDisabled) {
        <div
          class="card">
          <div class="card-body">
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseIsT2201 | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.doYouHaveExpensesThatAllowedYouToWorkOrAttendAnEducationalEstablishment | asAdvancedFormControl"></magieno-boolean-select>
          </div>
        </div>
      }
    </div>
  </div>


  <hr class="mt-5 mb-3">

  <div class="row">
    <div class="col-12">
      <h2> Aidant naturel </h2>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.areYouACaregiver | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.areYouACaregiver) {
        <div
          class="card">
          <div class="card-body">
            <magieno-datepicker
                    [advancedFormControl]="this.baseSpouseForm.formElements.caregiverStartDate | asAdvancedFormControl">
              <i class="fas fa-calendar" calendarIcon></i>
            </magieno-datepicker>
            <magieno-datepicker
                    [advancedFormControl]="this.baseSpouseForm.formElements.caregiverEndate | asAdvancedFormControl">
              <i class="fas fa-calendar" calendarIcon></i>
            </magieno-datepicker>
          </div>
        </div>
      }

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.areYouAccommodatingARelative | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.areYouAccommodatingARelative) {
        <div
          class="card">
          <div class="card-body">
            <magieno-input-text-field
              [advancedFormControl]="this.baseSpouseForm.formElements.relationshipWithAccommodatedRelative | asAdvancedFormControl"
              type="string"></magieno-input-text-field>
            <magieno-input-text-field
              [advancedFormControl]="this.baseSpouseForm.formElements.accommodatedRelativeFirstName | asAdvancedFormControl"
              type="string"></magieno-input-text-field>
            <magieno-input-text-field
              [advancedFormControl]="this.baseSpouseForm.formElements.accommodatedRelativeLastName | asAdvancedFormControl"
              type="string"></magieno-input-text-field>
            <magieno-input-text-field
              [advancedFormControl]="this.baseSpouseForm.formElements.accommodatedRelativeDisabilityName | asAdvancedFormControl"
              type="string"></magieno-input-text-field>
          </div>
        </div>
      }
    </div>
  </div>


  <hr class="mt-5 mb-3">

  <div class="row">
    <div class="col-12">
      <h2> Résidence </h2>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouReceivedRL31Slip | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.areYouAHomeOwner | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.areYouAHomeOwner) {
        <div
          class="card">
          <div class="card-body">
            <magieno-input-text-field
              [advancedFormControl]="this.baseSpouseForm.formElements.homeCadastralNumber | asAdvancedFormControl"
              type="string"></magieno-input-text-field>
          </div>
        </div>
      }

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPurchasedAHomeThisYear | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.haveYouPurchasedAHomeThisYear) {
        <div
          class="card">
          <div class="card-body">
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.inTheLast4YearsHaveYouResidedInAnotherHomeThatYouOrYourSpouseOwned | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPurchasedTheHomeForAFamilyMemberThatIsElligibleForTheDisabilityTaxCredit | asAdvancedFormControl"></magieno-boolean-select>
            @if (this.baseSpouseForm.value.inTheLast4YearsHaveYouResidedInAnotherHomeThatYouOrYourSpouseOwned || this.baseSpouseForm.value.haveYouPurchasedTheHomeForAFamilyMemberThatIsElligibleForTheDisabilityTaxCredit) {
              <div
                class="card">
                <div class="card-body">
                  <magieno-datepicker
                          [advancedFormControl]="this.baseSpouseForm.formElements.homePurchaseDate | asAdvancedFormControl">
                    <i class="fas fa-calendar" calendarIcon></i>
                  </magieno-datepicker>
                  <magieno-input-text-field
                    [advancedFormControl]="this.baseSpouseForm.formElements.homeCadastralNumber | asAdvancedFormControl"
                    type="string"></magieno-input-text-field>
                  <magieno-input-text-field
                    [advancedFormControl]="this.baseSpouseForm.formElements.homeOwnerFirstName | asAdvancedFormControl"
                    type="string"></magieno-input-text-field>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouSoldYourPrincipalResidence | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouMovedDuringThisYear | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.haveYouMovedDuringThisYear) {
        <div
          class="card">
          <div class="card-body">
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouMovedAtLeast40KilometresCloserToYourWorkLocation | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouMovedAtLeast40KilometresCloserToYourSchoolLocation | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouMovedInANewResidenceToAllowADisabledPersonToLiveInAMoreAccessibleLocation | asAdvancedFormControl"></magieno-boolean-select>
          </div>
        </div>
      }

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseAreRenovationsForDisability | asAdvancedFormControl"></magieno-boolean-select>


    </div>
  </div>

  <hr class="mt-5 mb-3">

  <div class="row">
    <div class="col-12">
      <h2> Placement </h2>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.doYouHaveAnyInvestments | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.doYouHaveAnyInvestments) {
        <div
          class="card">
          <div class="card-body">
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouReceivedAStatementOfInvestmentIncome | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.doYouHaveCapitalGainsOrLosses | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouReceivedAStatementOfPartnershipIncome | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouDisposedOfStockOptions | asAdvancedFormControl"></magieno-boolean-select>
            @if (this.baseSpouseForm.value.haveYouDisposedOfStockOptions) {
              <div
                class="card">
                <div class="card-body">
                  <magieno-boolean-select
                          [advancedFormControl]="this.baseSpouseForm.formElements.haveYouChosenToReportTheStockOptionsDisposal | asAdvancedFormControl"></magieno-boolean-select>
                </div>
              </div>
            }
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.doYouHaveBusinessInvestmentLosses | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.doYouHaveARentalIncome | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidInterestOnInvestments | asAdvancedFormControl"></magieno-boolean-select>
          </div>
        </div>
      }
    </div>
  </div>

  <hr class="mt-5 mb-3">

  <div class="row">
    <div class="col-12">
      <h2> REER </h2>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouWithdrawnFromARRSP | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouContributedToARRSP | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.haveYouContributedToARRSP) {
        <div
          class="card">
          <div class="card-body">
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPurchasedLabourSponsoredVentureCapitalCorporationShares | asAdvancedFormControl"></magieno-boolean-select>
          </div>
        </div>
      }

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseIsRAP | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.mainSpouseIsRAP) {
        <div
          class="card">
          <div class="card-body">
            <magieno-input-number-field
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseRAPYear | asAdvancedFormControl"></magieno-input-number-field>
            <magieno-input-money-field
              [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseRAPAmount | asAdvancedFormControl"
              [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>
          </div>
        </div>
      }

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseIsREEP | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.mainSpouseIsREEP) {
        <div
          class="card">
          <div class="card-body">
            <magieno-input-number-field
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseREEPYear | asAdvancedFormControl"></magieno-input-number-field>
            <magieno-input-money-field
              [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseREEPAmount | asAdvancedFormControl"
              [currency]="this.currency"
              [locale]="this.locale"></magieno-input-money-field>
          </div>
        </div>
      }

    </div>
  </div>

  <hr class="mt-5 mb-3">

  <div class="row">
    <div class="col-12">
      <h2> Frais médicaux </h2>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.doYouHaveNonReimbursedMedicalExpenses | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-select
              [advancedFormControl]="this.baseSpouseForm.formElements.wereYouEnrolledInADrugInsurancePlan | asAdvancedFormControl"></magieno-select>

      @if (this.baseSpouseForm.value.wereYouEnrolledInADrugInsurancePlan === prescriptionDrugInsuranceEnum.PartOfTheYear || this.baseSpouseForm.value.wereYouEnrolledInADrugInsurancePlan === prescriptionDrugInsuranceEnum.WholeYear) {
        <div
          class="card">
          <div class="card-body">
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.wasYourInsurancePremiumReimbursedByYourEmployer | asAdvancedFormControl"></magieno-boolean-select>
          </div>
        </div>
      }

      @if (this.baseSpouseForm.value.wereYouEnrolledInADrugInsurancePlan === prescriptionDrugInsuranceEnum.PartOfTheYear) {
        <div
          class="card">
          <div class="card-body">
            <div>
              Pour quels mois étiez-vous couvert par une assurance-médicament offerte par un régime d'assurance collective?
            </div>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseJanuary | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseFebruary | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseMarch | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseApril | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseMay | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseJune | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseJuly | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseAugust | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseSeptember | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseOctober | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseNovember | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseDecember | asAdvancedFormControl"></magieno-boolean-select>
          </div>
        </div>
      }

      <!--   todo add eventually *ngIf="this.baseSpouseForm.value.dateOfBirth && calculateAgeOnDecember31(this.baseSpouseForm.value.dateOfBirth) >= 65"-->
      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.didYouNeedToBeRegisteredToTheRAMQDrugInsurance | asAdvancedFormControl"></magieno-boolean-select>

    </div>
  </div>

  <hr class="mt-5 mb-3">

  <div class="row">
    <div class="col-12">
      <h2> Pension alimentaire </h2>
      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouReceivedAlimony | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.haveYouReceivedAlimony) {
        <div
          class="card">
          <div class="card-body">
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouReceivedChildSupport | asAdvancedFormControl"></magieno-boolean-select>
            @if (this.baseSpouseForm.value.haveYouReceivedChildSupport) {
              <div
                class="card">
                <div class="card-body">
                  <magieno-input-money-field
                    [advancedFormControl]="this.baseSpouseForm.formElements.childSupportAmount | asAdvancedFormControl"
                    [currency]="this.currency"
                    [locale]="this.locale"></magieno-input-money-field>
                </div>
              </div>
            }
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseIsAlimonyForExReceived | asAdvancedFormControl"></magieno-boolean-select>
            @if (this.baseSpouseForm.value.mainSpouseIsAlimonyForExReceived) {
              <div
                class="card">
                <div class="card-body">
                  <magieno-input-text-field
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseExName | asAdvancedFormControl"
                    type="string"></magieno-input-text-field>
                  <magieno-input-text-field
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseExAddress | asAdvancedFormControl"
                    type="string"></magieno-input-text-field>
                  <magieno-input-text-field
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseExSIN | asAdvancedFormControl"
                    type="string"></magieno-input-text-field>
                  <magieno-input-money-field
                    [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseAlimonyAmountForExReceived | asAdvancedFormControl"
                    [currency]="this.currency"
                    [locale]="this.locale"></magieno-input-money-field>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidAlimonyOrChildSupport | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.haveYouPaidAlimonyOrChildSupport) {
        <div
          class="card">
          <div class="card-body">
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidChildSupport | asAdvancedFormControl"></magieno-boolean-select>
            <magieno-boolean-select
                    [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidAlimony | asAdvancedFormControl"></magieno-boolean-select>
          </div>
        </div>
      }

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidLegalFeesRelatedToTheAlimonyOrChildSupport | asAdvancedFormControl"></magieno-boolean-select>

    </div>
  </div>

  <hr class="mt-5 mb-3">

  <div class="row">
    <div class="col-12">
      <h2> Autres revenus et déductions </h2>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.mainSpouseAreVirtualCurrency | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouEarnedAnyOtherIncome | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouReceivedAdvancePaymentsOfTaxCredits | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouMadeAnyDonations | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouMadePoliticalContributions | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidStudentLoanInterests | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidProfessionalFees | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidInfertilityRelatedFees | asAdvancedFormControl"></magieno-boolean-select>

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouPaidAdoptionFees | asAdvancedFormControl"></magieno-boolean-select>

      @if (this.baseSpouseForm.value.haveYouPaidAdoptionFees) {
        <div
          class="card">
          <div class="card-body">
            <magieno-input-text-field
              [advancedFormControl]="this.baseSpouseForm.formElements.adoptedChildFullName | asAdvancedFormControl"
              type="string"></magieno-input-text-field>
          </div>
        </div>
      }

      <magieno-boolean-select
              [advancedFormControl]="this.baseSpouseForm.formElements.haveYouMadeWaterPurificationUpgrades | asAdvancedFormControl"></magieno-boolean-select>
    </div>
  </div>

  <hr class="mt-5 mb-3">

  @if (this.isMainSpouse) {
    <div class="row">
      <div class="col-12">
        <h2> Information sur les enfants </h2>
        <magieno-boolean-select
                [advancedFormControl]="this.advancedForm.formElements.doYouHaveDependentChildren | asAdvancedFormControl"></magieno-boolean-select>
        @if (this.advancedForm.value.doYouHaveDependentChildren) {
          <div>
            @for (child of this.children.formGroups; track child; let i = $index) {
              <div class="card">
                <div class="row card-body">
                  <div class="row d-flex justify-content-between">
                    <div class="d-flex" style="width: fit-content">
                      <h2>Enfant #{{ i + 1 }}</h2>
                    </div>
                    @if (this.advancedForm.formElements.doYouHaveDependentChildren.lifecycleStatus === lifecycleStatusEnum.ReadyForInput) {
                      <div
                        class="dropdown d-flex"
                        style="width: fit-content">
                        <a aria-haspopup="true" class="dropdown-ellipses dropdown-toggle" data-bs-toggle="dropdown"
                          data-expanded="false" href="#" role="button">
                          <i class="fe fe-more-vertical"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a (click)="this.removeChild(i); $event.preventDefault()" class="dropdown-item"
                            href="#">
                            Supprimer
                          </a>
                        </div>
                      </div>
                    }
                  </div>
                  <app-quebec-2022-tax-questionnaire-child [childForm]="child" [form]="advancedForm"
                  [index]="i"></app-quebec-2022-tax-questionnaire-child>
                </div>
              </div>
            }
            @if (this.advancedForm.formElements.doYouHaveDependentChildren.lifecycleStatus === lifecycleStatusEnum.ReadyForInput) {
              <div
                class="card">
                <div (click)="this.addChild()" class="card-body" style="cursor: pointer">
                  <a (click)="$event.preventDefault()" href="#shareClass" id="addShareClassButton">+ Ajouter un
                  enfant</a>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
